module.exports = __webpack_public_path__ + "img/faviconBlanco.cc711a7b.png";